module.exports = __webpack_public_path__ + "static/fonts/LavaPro-Reg.f14fbf7.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-Reg.otf
// module id = /vTW
// module chunks = 0